import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div data-test-payment-link-paid>\n  <h1>Paid</h1>\n</div>\n",{ moduleName: "client-portal/components/payment-link/paid.hbs" })